import { h as __h } from "preact";
import { signal } from "@preact/signals";
import { Component, createRef } from "preact";
/** @import { RefObject } from "preact"; */
/** @import { DropdownItem } from "~/component/Dropdown.js"; */

import { identity } from "~/lib/identity.js";
import { logOut } from "~/lib/login.js";
import html from "~/util/html.js";
import { navigate } from "~/util/router.js";
import Avatar from "~/component/Avatar.js";
import Button from "~/component/Button.js";
import Dropdown from "~/component/Dropdown.js";
import HelpModal from "~/component/HelpModal.js";
import Modal from "~/component/Modal.js";
import AccountSettings from "./AccountSettings/AccountSettings.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./UserDropdown.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./UserDropdown.module.css", import.meta.url);
const css = adopt(sheet);
const HELP_URL = "https://help.phaze.app";

/**
 * @extends {Component<Props>}
 *
 * @typedef {object} Props
 * @property {boolean} [showLogOut]
 * @property {true} [modal]
 * @property {(form: string) => void} [openURL]
 * @property {boolean} [confirmLogout]
 */
export default class UserDropdown extends Component {
  onLogout() {
    if (this.props.confirmLogout) {
      this.logoutModal.current?.open();
    } else {
      logOut();
    }
  }
  /** @type {RefObject<Modal>} */
  logoutModal = createRef();
  showHelp = signal(false);
  showSettings = signal(false);
  render() {
    const {
      openURL = window.open,
      showLogOut = true
    } = this.props;

    /** @type {DropdownItem[]} */
    const items = [{
      text: "Help",
      icon: "help",
      onSelect: () => openURL(HELP_URL)
    }, {
      text: "Account",
      icon: "gear",
      onSelect: () => {
        if (this.props.modal) {
          this.showSettings.value = true;
        } else navigate("/account/");
      }
    }];
    if (showLogOut) {
      items.push({
        text: "Log out",
        icon: "exit",
        onSelect: () => this.onLogout()
      });
    }
    return [__h(Dropdown, {
      id: "user-dropdown",
      placement: "top-start",
      trigger: __h("button", {
        "class": css.userButton,
        popovertarget: "user-dropdown"
      }, __h(Avatar, {
        name: identity.me?.name ?? ""
      }), __h("span", {
        "aria-hidden": "true"
      }, identity.me?.name)),
      items: items
    }), this.props.modal && __h(Modal, {
      title: "Account",
      open: this.showSettings.value,
      onClose: () => {
        this.showSettings.value = false;
      }
    }, __h("div", {
      "class": css.settings
    }, __h(AccountSettings, {
      flat: true
    }))), __h(LogoutModal, {
      modalRef: this.logoutModal,
      onConfirm: logOut
    }), __h(HelpModal, {
      open: this.showHelp.value,
      onClose: () => {
        this.showHelp.value = false;
      }
    })];
  }
}

/** @param {{ modalRef: RefObject<Modal>; onConfirm: () => void }} props */
function LogoutModal({
  modalRef,
  onConfirm
}) {
  const onSubmit = (/** @type {SubmitEvent} */ev) => {
    if (ev.submitter?.getAttribute("value") === "disable") onConfirm();
  };
  return __h(Modal, {
    ref: modalRef,
    title: "Are you sure you want to log out?"
  }, __h("div", {
    "class": css.logoutModal
  }, __h("p", {}, "You will no longer be able to connect to this computer."), __h("form", {
    onSubmit: onSubmit
  }, __h(Button, {
    type: "submit",
    formmethod: "dialog"
  }, "Cancel"), __h(Button, {
    type: "submit",
    level: "primary",
    kind: "negative",
    formmethod: "dialog",
    value: "logout"
  }, "Log out"))));
}